import { render, staticRenderFns } from "./MultiplePaid.vue?vue&type=template&id=2bf58d68"
import script from "./MultiplePaid.vue?vue&type=script&lang=js"
export * from "./MultiplePaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports